export const TIME_CHART_BREAKPOINT = {
  M: 600,
  S: 450,
  XS: 300,
} as const;

// Important this is ordered ascending for the `getMaxWidthBreakpoint` below to
// grab the right first value. Setting this once as a constant instead of inside
// the method to reduce the overhead.
const TIME_CHART_BREAKPOINT_MAX_WIDTHS = Object.values(TIME_CHART_BREAKPOINT).sort();

const minMs = 60000;
const hourMs = 3600000;
const dayMs = 86400000;

function getMaxWidthBreakpoint(width: number) {
  return TIME_CHART_BREAKPOINT_MAX_WIDTHS.find((breakpointWidth) => width <= breakpointWidth);
}

/**
 * Calculate the xAxis minimum interval based on the time range and the maximum width boundary.
 */
export function getXAxisMinInterval(width: number, rangeMs: number) {
  const maxWidth = getMaxWidthBreakpoint(width);

  // less than 300px
  if (maxWidth === TIME_CHART_BREAKPOINT.XS) {
    // between 15 and 30 mins
    if (minMs * 15 <= rangeMs && rangeMs < minMs * 30) {
      // minInterval will only work if the number is slightly greater than the desired value
      return minMs * 6; // ~5 mins
    }

    // between 30 mins and an hour
    if (minMs * 30 <= rangeMs && rangeMs < hourMs) {
      return minMs * 11; // ~10 mins
    }

    // between an hour and 6 hours
    if (hourMs <= rangeMs && rangeMs < hourMs * 6) {
      return minMs * 16; // ~15 mins
    }

    // between 6 and 12 hours
    if (hourMs * 6 <= rangeMs && rangeMs < hourMs * 12) {
      return hourMs * 2.1; // ~2 hours
    }

    // between 12 and 1 day
    if (hourMs * 12 <= rangeMs && rangeMs < dayMs) {
      return hourMs * 4.1; // ~4 hours
    }

    // greater than 1 day
    if (dayMs <= rangeMs) {
      return hourMs * 6.1; // ~6 hours
    }
  }

  // less than 450px
  if (maxWidth === TIME_CHART_BREAKPOINT.S) {
    // between 15 and 30 mins
    if (minMs * 15 <= rangeMs && rangeMs <= minMs * 30) {
      // minInterval will only work if the number is slightly greater than the desired value
      return minMs * 6; // ~5 mins
    }

    // between 30 mins and 2 hours
    if (minMs * 30 < rangeMs && rangeMs < hourMs * 2) {
      return minMs * 11; // ~10 mins
    }

    // between 2 hours and 6 hours
    if (hourMs * 2 <= rangeMs && rangeMs <= hourMs * 6) {
      return minMs * 31; // ~30 mins
    }

    // greater than 6 hours
    if (hourMs * 6 < rangeMs) {
      return hourMs * 2.1; // ~2 hours
    }
  }

  // less than 600px
  if (maxWidth === TIME_CHART_BREAKPOINT.M) {
    if (minMs * 15 <= rangeMs && rangeMs < hourMs) {
      return minMs * 6; // ~5 mins
    }

    // between an hour to 2 hours
    if (hourMs <= rangeMs && rangeMs < hourMs * 2) {
      return minMs * 11; // ~10 mins
    }

    // between 2 hours and 6 hours
    if (hourMs * 2 <= rangeMs && rangeMs <= hourMs * 6) {
      return minMs * 31; // ~30 mins
    }

    // greater than 6 hours
    if (hourMs * 6 < rangeMs) {
      return hourMs * 2.1; // ~2 hours
    }
  }
}
